export const titleSuffix = " - Inlab Genetics";
export const notSelectedId = -1;
export const notSelectedString = "not_selected";
export const infiniteCount = -1;
export const FETCH_ALL_ROWS = 10000;

export const bitrixUrl = ((process.env.BITRIX_URL as string | undefined) ?? "").replace(/\/+$/, "");

export const BY_COURT_ORDER_ALIAS = "byCourtOrder";
export const BEFORE_COURT_ORDER_ALIAS = "beforeCourtOrder";

const BITRIX_PRODUCTION_URL = "https://ctd-crm-portal.ru";
const BITRIX_TEST_URL = "https://b24-dev.dnkcloud-ctd.net";

const BITRIX_URLS_BY_HOSTNAME: Record<string, string> = {
    "lk.test.inlab-genetics.ru": BITRIX_TEST_URL,
};

export function getBitrixBaseUrl(hostname = window.location.hostname): string {
    return bitrixUrl || BITRIX_URLS_BY_HOSTNAME[hostname] || BITRIX_PRODUCTION_URL;
}

export function getBitrixDealUrl(bitrixId: string | number): string {
    return `${getBitrixBaseUrl()}/crm/deal/details/${bitrixId}/`;
}
